import * as React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "components/bootstrap";
import SharingDisabledPopover from "components/permissions/SharingDisabledPopover";
import HasOwnership from "components/common/HasOwnership";
const ShareMenuItem = ({ entityId, entityType, onClick, disabledInfo = void 0, title = void 0 }) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(HasOwnership, { id: entityId, type: entityType }, ({ disabled: hasMissingPermissions }) => /* @__PURE__ */ React.createElement(
    MenuItem,
    {
      onSelect: onClick,
      disabled: !!disabledInfo || hasMissingPermissions,
      title: t("share_menu_item.share")
    },
    title != null ? title : t("share_menu_item.share"),
    " ",
    (!!disabledInfo || hasMissingPermissions) && /* @__PURE__ */ React.createElement(SharingDisabledPopover, { type: entityType, description: disabledInfo })
  ));
};
export default ShareMenuItem;
